/** Lingua dell'interfaccia: scelta sulla postazione, non sul conto.
 *
 * **Inglese per difetto, dal 07.09.2026 (GI-237).** L'italiano resta a un
 * clic, nella barra in alto; ma chi apre la pagina per la prima volta la
 * trova in inglese. E' la lingua in cui si legge il prodotto fuori dalla
 * squadra, ed e' quella che il committente della piattaforma ha chiesto. */

export type Locale = 'it' | 'en'

export const DEFAULT_LOCALE: Locale = 'en'
export const STORAGE_KEY = 'gridfly.locale'

let current: Locale = DEFAULT_LOCALE

/** Lingua in vigore su questa scheda, anche fuori da React. */
export function currentLocale(): Locale {
  return current
}

export function setCurrentLocale(next: Locale): void {
  current = next
}

export function isLocale(value: unknown): value is Locale {
  return value === 'it' || value === 'en'
}

export function readStored(): Locale {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    return isLocale(raw) ? raw : DEFAULT_LOCALE
  } catch {
    return DEFAULT_LOCALE
  }
}

export function writeStored(locale: Locale): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, locale)
  } catch {
    // Senza memoria la scelta resta solo nello stato React.
  }
}
